export default {
  apiKey: "AIzaSyCRztlVVFeXNCegc1YK7EEhpjqnlB_zcl0",
    authDomain: "emc-kr-dev-d.firebaseapp.com",
    databaseURL: "https://emc-kr-dev-d.firebaseio.com",
    projectId: "emc-kr-dev-d",
    storageBucket: "emc-kr-dev-d.appspot.com",
    messagingSenderId: "359668273288",
    appId: "1:359668273288:web:1adaefc2d8b64c8ad68f3d",
    measurementId: "G-YYKCJJRF05"
}